import { FloorConfig } from "../components/Map/plugins/floor-control";

export const buildRouteData = ({
  fromId,
  toId,
  floor,
}: {
  fromId: string;
  toId: string;
  floor?: FloorConfig;
}) => {
  const splitFromId = fromId?.split(",");
  const splitToId = toId?.split(",");

  const fromIdIsLatLng = splitFromId?.length === 2;
  const toIdIsLatLng = splitToId?.length === 2;

  const fromData = fromIdIsLatLng
    ? {
        from_latitude: Number(splitFromId[1]),
        from_longitude: Number(splitFromId[0]),
        from_floor: floor?.floor,
      }
    : {
        from_lm_id: fromId,
      };

  const toData = toIdIsLatLng
    ? {
        to_latitude: Number(splitToId[1]),
        to_longitude: Number(splitToId[0]),
        to_floor: floor?.floor,
      }
    : { to_lm_id: toId };

  return {
    fromData,
    toData,
  };
};
